var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:_vm.showSeeBackground ? 'app-container-background' : ''},[(_vm.preloading)?void 0:_c('router-view')],2)}
var staticRenderFns = []

export { render, staticRenderFns }